import { SubscriptionCardData } from './SubscriptionCard'

export const monthlyPricingData: SubscriptionCardData[] = [
  {
    addon: {
      description:
        'Add additional data fetches anytime during the month at a reduced rate.',
      name: 'Extra Data Fetch',
      price: '$25 / month',
    },
    ctaText: 'Get Plan',
    defaultFeatures: [
      { included: true, text: '1 Data fetches per month' },
      { included: true, text: '6 Selected Target Channels' },
      { included: true, text: 'Up to 5 Monitoring Campaigns' },
      { included: true, text: '5 Unique Keywords (variations not included)' },
      { included: true, text: 'Unlimited Sentiment Analysis' },
      { included: true, text: 'Unlimited AI Insights & Recommendations' },
      { included: true, text: 'Monthly Summary Report' },
    ],
    description:
      "Best for teams that need periodic insights and high-level reporting without continuous monitoring. Perfect if you're looking for a clear monthly snapshot of your digital presence.",
    frequency: '1 data fetch per month',
    id: 'monthly-data-fetch',
    optionalFeatures: [
      { included: false, text: 'AI Assistant' },
      { included: false, text: 'Inbox Analysis' },
      { included: false, text: 'Content Analysis' },
      { included: false, text: 'Review Analysis' },
      { included: false, text: 'Custom Alerts' },
      { included: false, text: 'Custom Reporting' },
    ],
    period: 'month',
    price: 149,
    title: 'Monthly Data Fetch',
  },
  {
    addon: {
      description:
        'Add additional data fetches anytime during the week at a reduced rate.',
      name: 'Extra Data Fetch',
      price: '$20 / month',
    },
    ctaText: 'Get Plan',
    defaultFeatures: [
      { included: true, text: '4 Data fetches per month' },
      { included: true, text: '6 Selected Target Channels' },
      { included: true, text: 'Up to 5 Monitoring Campaigns' },
      { included: true, text: '5 Unique Keywords (variations not included)' },
      { included: true, text: 'Unlimited Sentiment Analysis' },
      { included: true, text: 'Unlimited AI Insights & Recommendations' },
      { included: true, text: 'Weekly Summary Report' },
    ],
    description:
      'Best for teams that need regular insights and structured reporting without full real-time monitoring. Ideal for tracking trends week by week while maintaining a clear, consolidated overview.',
    frequency: '4 data fetches (once a week) per month',
    id: 'weekly-data-fetch',
    optionalFeatures: [
      { included: false, text: 'AI Assistant' },
      { included: false, text: 'Inbox Analysis' },
      { included: false, text: 'Content Analysis' },
      { included: false, text: 'Review Analysis' },
      { included: false, text: 'Custom Alerts' },
      { included: false, text: 'Custom Reporting' },
    ],
    period: 'month',
    price: 499,
    title: 'Weekly Data Fetch',
  },
  {
    addon: {
      description:
        'Add additional data fetches anytime during the day at a reduced rate.',
      name: 'Extra Data Fetch',
      price: '$20 / month',
    },
    ctaText: 'Get Plan',
    defaultFeatures: [
      { included: true, text: '30/31 data fetches (once a day) per month' },
      { included: true, text: '6 Selected Target Channels' },
      { included: true, text: 'Up to 5 Monitoring Campaigns' },
      { included: true, text: '5 Unique Keywords (variations not included)' },
      { included: true, text: 'Unlimited Sentiment Analysis' },
      { included: true, text: 'Unlimited AI Insights & Recommendations' },
      { included: true, text: 'Daily Summary Report' },
    ],
    description:
      'Best for teams that need frequent insights, faster trend detection, and continuous visibility. Ideal for brands that want to stay closely aligned with daily narrative shifts and performance signals.',
    frequency: '30/31 data fetches (once a day) per month',
    id: 'daily-data-fetch',
    optionalFeatures: [
      { included: false, text: 'AI Assistant' },
      { included: false, text: 'Inbox Analysis' },
      { included: false, text: 'Content Analysis' },
      { included: false, text: 'Review Analysis' },
      { included: false, text: 'Custom Alerts' },
      { included: false, text: 'Custom Reporting' },
    ],
    period: 'month',
    price: 1099,
    title: 'Daily Data Fetch',
  },
]

export const annuallyPricingData: SubscriptionCardData[] = [
  {
    addon: {
      description:
        'Add additional data fetches anytime during the month at a reduced rate.',
      name: 'Extra Data Fetch',
      price: '$25 / month',
    },
    ctaText: 'Get Plan',
    defaultFeatures: [
      { included: true, text: '1 Data fetches per month' },
      { included: true, text: '6 Selected Target Channels' },
      { included: true, text: 'Up to 5 Monitoring Campaigns' },
      { included: true, text: '5 Unique Keywords (variations not included)' },
      { included: true, text: 'Unlimited Sentiment Analysis' },
      { included: true, text: 'Unlimited AI Insights & Recommendations' },
      { included: true, text: 'Monthly Summary Report' },
    ],
    description:
      "Best for teams that need periodic insights and high-level reporting without continuous monitoring. Perfect if you're looking for a clear monthly snapshot of your digital presence.",
    frequency: '1 data fetch per month',
    id: 'monthly-data-fetch',
    optionalFeatures: [
      { included: false, text: 'AI Assistant' },
      { included: false, text: 'Inbox Analysis' },
      { included: false, text: 'Content Analysis' },
      { included: false, text: 'Review Analysis' },
      { included: false, text: 'Custom Alerts' },
      { included: false, text: 'Custom Reporting' },
    ],
    originalPrice: 149,
    period: 'month',
    price: 129,
    savingsBadge: 'Save up to 15%',
    savingsBadgeType: 'red',
    title: 'Monthly Data Fetch',
  },
  {
    addon: {
      description:
        'Add additional data fetches anytime during the week at a reduced rate.',
      name: 'Extra Data Fetch',
      price: '$20 / month',
    },
    ctaText: 'Get Plan',
    defaultFeatures: [
      { included: true, text: '4 Data fetches per month' },
      { included: true, text: '6 Selected Target Channels' },
      { included: true, text: 'Up to 5 Monitoring Campaigns' },
      { included: true, text: '5 Unique Keywords (variations not included)' },
      { included: true, text: 'Unlimited Sentiment Analysis' },
      { included: true, text: 'Unlimited AI Insights & Recommendations' },
      { included: true, text: 'Weekly Summary Report' },
    ],
    description:
      'Best for teams that need regular insights and structured reporting without full real-time monitoring. Ideal for tracking trends week by week while maintaining a clear, consolidated overview.',
    frequency: '4 data fetches (once a week) per month',
    id: 'weekly-data-fetch',
    optionalFeatures: [
      { included: false, text: 'AI Assistant' },
      { included: false, text: 'Inbox Analysis' },
      { included: false, text: 'Content Analysis' },
      { included: false, text: 'Review Analysis' },
      { included: false, text: 'Custom Alerts' },
      { included: false, text: 'Custom Reporting' },
    ],
    originalPrice: 499,
    period: 'month',
    price: 459,
    savingsBadge: 'Save up to 15%',
    savingsBadgeType: 'red',
    title: 'Weekly Data Fetch',
  },
  {
    addon: {
      description:
        'Add additional data fetches anytime during the day at a reduced rate.',
      name: 'Extra Data Fetch',
      price: '$20 / month',
    },
    ctaText: 'Get Plan',
    defaultFeatures: [
      { included: true, text: '30/31 data fetches (once a day) per month' },
      { included: true, text: '6 Selected Target Channels' },
      { included: true, text: 'Up to 5 Monitoring Campaigns' },
      { included: true, text: '5 Unique Keywords (variations not included)' },
      { included: true, text: 'Unlimited Sentiment Analysis' },
      { included: true, text: 'Unlimited AI Insights & Recommendations' },
      { included: true, text: 'Daily Summary Report' },
    ],
    description:
      'Best for teams that need frequent insights, faster trend detection, and continuous visibility. Ideal for brands that want to stay closely aligned with daily narrative shifts and performance signals.',
    frequency: '30/31 data fetches (once a day) per month',
    id: 'daily-data-fetch',
    optionalFeatures: [
      { included: false, text: 'AI Assistant' },
      { included: false, text: 'Inbox Analysis' },
      { included: false, text: 'Content Analysis' },
      { included: false, text: 'Review Analysis' },
      { included: false, text: 'Custom Alerts' },
      { included: false, text: 'Custom Reporting' },
    ],
    originalPrice: 1099,
    period: 'month',
    price: 949,
    savingsBadge: 'Save up to 15%',
    savingsBadgeType: 'red',
    title: 'Daily Data Fetch',
  },
]
